import { NodeDefinition } from "src/types/node.types";
import { falsoNodeDefs } from "./falso";
import * as fakoNodeDefs from "./fako";

export const nodeDefList = [
  ...Object.values(fakoNodeDefs),
  ...falsoNodeDefs,
].sort((a, b) => a.displayName.localeCompare(b.displayName));

export const nodeDefs = nodeDefList.reduce<
  Record<string, NodeDefinition<any, any>>
>((acc, def) => {
  if (def.type in acc) throw new Error("Duplicate type " + def.type);

  acc[def.type] = def;
  return acc;
}, {});
